import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

Info.propTypes = {
  item: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default function Info(props) {
  const { item, action, onClick, disabled = false } = props;
  return (
    <>
      <Typography variant="h3">{item.title}</Typography>
      <Typography variant="body">{item.description}</Typography>
      <Typography variant="body">{item.label}</Typography>
    </>
  );
}
